import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import qs from 'query-string';

import { Flex, Text } from '../../../Components/Base';
import Loading from '../../../Components/Loading';
import { useCapacitor } from '../../../Util/Capacitors';
import { LOGIN_LOADING_TIMEOUT } from '../../../Util/Capacitors/constant';
import getConfig from '../../../Util/Config';
import { isTungKaiHandOffEnabled } from '../../../Util/isTungKaiHandOffEnabled';
import { navigateToTungKai } from '../../../Util/navigateToTungKai';

let timeout;

const LoginLoading = ({ isLogin, loginError, clearLoginError, history, t, location, user }) => {
  const config = getConfig();
  const { landingRoute = '/my-courses' } = config;
  const { openInApp } = useCapacitor();
  let redirectPath = landingRoute;
  if (location.search) {
    const query = qs.parse(location.search);
    if (query.redirectPath) {
      redirectPath = `${query.redirectPath}`;
    }
  }

  useEffect(() => {
    if (isLogin) {
      clearTimeout(timeout);
      const { cookieSyncDomain } = config;
      if (window.wkWebView) {
        window.wkWebView.injectCookie(cookieSyncDomain);
      }
      if (isTungKaiHandOffEnabled(config, user?.id) && openInApp) {
        navigateToTungKai({ config, openInApp }).catch(() => history.push(redirectPath));
        return;
      }
      history.push(redirectPath);
    } else if (loginError) {
      clearTimeout(timeout);
      clearLoginError();
      history.push('/');
    } else {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        clearTimeout(timeout);
        history.push('/');
      }, LOGIN_LOADING_TIMEOUT);
    }
  }, [isLogin]);

  return (
    <Flex justifyContent={'center'} alignItems={'center'} height={'100vh'}>
      <Loading />
    </Flex>
  );
};

export default withTranslation('registerLogin')(LoginLoading);
